module.exports = __webpack_public_path__ + "img/koincapital@2x.a792298.png";